module.exports = __webpack_public_path__ + "img/universe-landing-4.b34e85e1.jpg";